import "react-toastify/dist/ReactToastify.css";
import "./App.css"

import { Route, Routes } from "react-router-dom";

import AddCv from "./components/AddCv";
import { AuthProvider } from "providers/AuthProvider";
import BreadCrumb from "./components/BreadCrumb";
import CandidateForm from "./pages/CandidateForm";
import { CssBaseline } from "@mui/material";
import CvDashBoard from "./pages/CVDashBoard";
import CvDetails from "./pages/CvDetails";
import FilesAndMedia from "./pages/FilesAndMedia";
import Header from "./components/Header";
import Home from "pages/Home";
import NotFound from "./pages/NotFound";
import { ProfileProvider } from "providers/ProfileProvider";
import { CandidateProvider } from "providers/CandidateProvider";
import ProtectedRoute from "./components/ProtectedRoute";
import { ThemeProvider } from '@mui/material/styles';
import UserInfo from "./pages/UserInfo";
import theme from './theme';
import Profile from "pages/Profile";
import Account from "pages/Account";
import Admin from "pages/Admin";
import AdminSearch from "pages/AdminSearch";
import AdminManageOpportunities from "pages/AdminManageOpportunities";
import AdminUserManagement from "pages/AdminUserManagement";
import AdminInvites from "pages/AdminInvites";
import MainLayout from "layouts/MainLayout";
import TermsAndConditions from "pages/TermsAndConditions";

function App() {
  return (
    <AuthProvider>
      <ProfileProvider>
        <CandidateProvider>
          <ThemeProvider theme={theme}>
          <Header />
          <BreadCrumb />
          <div className="App">
            <Routes>
              <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
              <Route path="/*" element={
                <ProtectedRoute>
                  <Routes>
                    <Route path="/onboarding" element={<CandidateForm />} />
                    <Route path="/profile" element={<Profile />} />
                    <Route path="/account" element={<Account />} />
                    <Route path="/admin" element={<Admin />} />
                    <Route path="/admin/search" element={<MainLayout><AdminSearch /></MainLayout>} />
                    <Route path="/admin/users" element={<MainLayout><AdminUserManagement /></MainLayout>} />
                    <Route path="/admin/invites" element={<MainLayout><AdminInvites /></MainLayout>} />
                    <Route path="/admin/opportunities" element={<MainLayout><AdminManageOpportunities /></MainLayout>} />
                    <Route path="/" element={<Home />} />
                    <Route path="/cvs" element={<MainLayout><CvDashBoard /></MainLayout>} />
                    <Route path="/cv/:id" element={<MainLayout disablePadding><CvDetails /></MainLayout>} />
                    <Route path="/uploaded-files" element={<MainLayout><FilesAndMedia /></MainLayout>} />
                    <Route path="/userinfo/:id" element={<UserInfo />} />
                    <Route path="/AddCv" element={<AddCv />} />
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </ProtectedRoute>
              } />
            </Routes>
            <CssBaseline />
          </div>
        </ThemeProvider>
        </CandidateProvider>
      </ProfileProvider>
    </AuthProvider>
  );
}

export default App;